import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, FormArray } from '@angular/forms';
import { OperatingCarrier } from 'src/app/core/models/voluntary-change.model';
import { map, filter } from 'rxjs/operators';

interface ActionsFormManager {
  addAirline: () => void;
  delete: (index: number) => void;
}
@Component({
  selector: 'app-search-airline',
  templateUrl: './search-airline.component.html',
  styleUrls: ['./search-airline.component.scss']
})
export class SearchAirlineComponent implements OnInit {
  @Input() selectedAirline: OperatingCarrier;
  @Input() airlines: OperatingCarrier[];
  @Input() placeholder: string;
  @Input() label: string;
  @Input() errorMessage: string;
  @Input() submitted: boolean;
  @Input() disabled: boolean;
  @Output() selectedAirlineChange = new EventEmitter<OperatingCarrier>();

  form: FormGroup;
  formControl: FormControl;

  constructor(private fb: FormBuilder) { this.buildForm(); }

  ngOnInit(): void {
    this.getListItem(this.selectedAirline);
    this.form.controls.airlineTemp.setValue(this.getListItem(this.selectedAirline));
    this.addAirline();
  }

  emitSelectedAirline(): void {
    this.selectedAirlineChange.emit(this.form.getRawValue().airlines)
  }

  get formManager(): ActionsFormManager {
    return {
      addAirline: this.addAirline.bind(this),
      delete: this.delete.bind(this)
    };
  }

  getListItem(airline: OperatingCarrier) {

    if (!airline) { return null; }
    return {
      ...airline,
      label: `${airline.code || ''} - ${airline.name || ''}`
    }
  }

  trackIndex(index: number): number {
    return index;
  }

  addAirline() {
    if (this.validateAirline()) {
      return;
    }
    const airlines = new FormArray([
      ...[...this.form.controls.airlines.value, this.form.controls.airlineTemp.value].map(
        (item: OperatingCarrier) => new FormControl(item)
      )
    ]);
    this.form.setControl('airlines', airlines);
    this.form.controls.airlineTemp.reset();
    this.emitSelectedAirline();
  }

  delete(_code: string): void {
    const airlines = new FormArray([
      ...this.form.controls.airlines.value
        .filter(({ code }) => code !== _code)
        .map((item: OperatingCarrier) => new FormControl(item))
    ]);
    this.form.setControl('airlines', airlines);
    this.emitSelectedAirline();
  }

  private buildForm(): void {
    this.formControl = new FormControl(null)
    this.form = this.fb.group({
      airlineTemp: this.formControl,
      airlines: new FormArray([])
    })
  }

  private validateAirline(): boolean {
    const airline = this.form.controls.airlineTemp.value;
    return !airline || this.form.controls.airlines.value.map((airline) => airline.code).some((value) => value === airline.code);
  }

}
